import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface ModuleApiItem {
  _id: string;
  name: string;
  description?: string;
  meta?: {
    status?: string;
    createdAt?: string;
    updatedAt?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface ModulesResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    modules?: ModuleApiItem[];
  };
}

export const getModules = async (): Promise<ModulesResponse> => {
  return api.get<ModulesResponse>(API_ENDPOINTS.modules.list);
};
